import { Platform } from 'react-native'

export default function appBrowserBrowserFileUri(uri: string): string {
  const isiOS = Platform.OS === 'ios'
  const isAndroid = Platform.OS === 'android'
  const isFile = /\.(pdf|doc|xls|csv)(\?.*)?$/i
  const source =
    (isiOS || isAndroid) && isFile.test(uri)
      ? // defaulting to use docs viewer for android since webview will is not compatible
        // potentially move this to use react-native-pdf-view
        // https://github.com/react-native-webview/react-native-webview/issues/1342
        `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(uri)}`
      : uri
  return source
}
